<script setup>

import {ref} from "vue";
import NotificationBell from "../Components/NotificationBell/NotificationBell.vue";

const drawer = ref(true);
</script>

<template>
    <v-card color="#F5F5F5">
        <v-layout>
            <v-navigation-drawer
                v-model="drawer"
                color="#091736"
                width="320"
            >
                <template v-slot:prepend>
                    <v-img src="/images/aanew.jpg" class="mainLogo"/>

                    <slot name="sidebar-top"></slot>
                </template>

                <v-sheet color="#091736">
                    <v-list density="compact">
                        <v-divider horizontal/>

                        <div class="mt-5 ml-8 body-2 overline font-weight-black">
                            My Shortcuts
                        </div>

                        <slot name="sidebar-shortcuts"></slot>
                    </v-list>
                </v-sheet>
                <v-divider horizontal/>

                <template v-slot:append>
                    <slot name="sidebar-bottom"></slot>
                </template>
            </v-navigation-drawer>

            <v-app-bar
                color="#4a90e2"
                prominent
            >
                <v-app-bar-nav-icon @click.stop="drawer = !drawer"/>
                <v-spacer/>
                <NotificationBell/>
            </v-app-bar>

            <v-main style="height: 100%">
                <v-card-text>
                    <main>
                        <slot name="page-content"></slot>
                    </main>
                </v-card-text>
            </v-main>
        </v-layout>
    </v-card>
</template>